import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import VirtualizedSelect from 'react-virtualized-select';
import '../shared/virtualized-select.css';
import FuseTheme from '../global/theme';

/**
 * An Input component for a React Virtualized Select, using an array of objects for the options
 *
 * The object passed as `options` props is passed to the material-ui <SelectField> component
 */
export class VirtualizedSelectInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorText: null,
            loading: true,
            value: this.props.input.value,
        };
    }

    componentWillMount() {
        if (this.props.choices && this.props.choices.length > 0) {
            this.setState({
                loading: false
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.choices !== this.props.choices) {
            if (nextProps.choices && nextProps.choices.length > 0) {
                // Loading is complete when choices are available
                this.setState({
                    loading: false
                });
            }
        }
        if (nextProps.isLoading !== this.props.isLoading) {
            // Loading is set by admin.state
            this.setState({
                loading: nextProps.isLoading
            });
        }
        if (nextProps.input.value !== this.props.input.value) {
            this.setState({
                value: nextProps.input.value
            });
            this.checkForRequiredError(nextProps.input.value);
        }
        if (nextProps.meta.submitFailed !== this.props.meta.submitFailed) {
            this.checkForRequiredError(nextProps.input.value);
        }
    }

    handleBlur = (event) => {
        this.checkForRequiredError(this.props.input.value);
    };

    checkForRequiredError = (value) => {
        let isValid = true;
        if (this.props.required && !value) {
            isValid = false;
        }
        this.setState({
            errorText: (isValid) ? '' : this.props.errorMessage
        });
    };

    handleChange = (event, index, value) => {
        let selectionValue = null;
        if (event) {
            selectionValue = event[this.props.optionValue];
        }
        this.props.input.onChange(selectionValue);
        this.setState({selectionValue});
        this.checkForRequiredError(selectionValue);
    };

    render() {
        const {
            choices,
            required,
            label,
            meta,
            options,
            optionText,
            optionValue,
            source,
        } = this.props;
        if (typeof meta === 'undefined') {
            throw new Error(
                "The VirtualizedSelectInput component requires meta props."
            );
        }
        const styles = {
            select: {fontSize: 16},
            errorText: {
                display: 'block',
                fontSize: 12,
                color: FuseTheme.palette.errorColor,
                margin: '0 0 1em 0',
            },
        };

        return (
            [
                <VirtualizedSelect
                    key={`select-${source}`}
                    className={(this.state.errorText) ? 'is-invalid' : ''}
                    name={source}
                    value={this.state.value}
                    label={label}
                    options={choices}
                    isLoading={this.state.loading}
                    labelKey={optionText}
                    valueKey={optionValue}
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}
                    isRequired={required}
                    style={styles.select}
                    {...options}
                />,
                <span key={`message-${source}`}>
                    {this.state.errorText &&
                    <span style={styles.errorText}>{this.state.errorText}</span>
                    }
                    </span>
            ]
        );
    }
}

VirtualizedSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    choices: PropTypes.arrayOf(PropTypes.object),
    elStyle: PropTypes.object,
    errorMessage: PropTypes.string,
    input: PropTypes.object,
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.object,
    optionText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.element,
    ]).isRequired,
    optionValue: PropTypes.string.isRequired,
    required: PropTypes.bool,
    resource: PropTypes.string,
    source: PropTypes.string,
};

VirtualizedSelectInput.defaultProps = {
    addField: true,
    choices: [],
    errorMessage: 'Required',
    isLoading: false,
    required: false,
    label: 'Select:',
    options: {},
    optionText: 'name',
    optionValue: 'id',
};

export default connect()(VirtualizedSelectInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/VirtualizedSelectInput.js